<template>
    <div class="w-full" v-if="departListShow">
        <div class="max-sm:hidden web_depart">
            <div class="flex items-center text-base cursor-pointer mb-2.5" @click="templateShow = !templateShow">
                <img src="@/assets/icon_template.png" alt="">
                <span class="ml-[5px]">提问模板</span>
            </div>
            <div v-show="templateShow">
                <div class="tab_box">
                    <div class="depart_tab" ref="scrollBox" @wheel="onWheel">
                        <span class="py-1.5 mr-5" @click="changeTab(item, key)" :class="{active: key == selectedIndex}" 
                            v-for="(item, key) in departList" :key="key"
                        >{{item.name}}</span>
                    </div>
                </div>
                <div class="tip_list" 
                    element-loading-text="模板加载中"
                    element-loading-spinner="el-icon-loading"
                    v-loading="loading"
                >
                    <div class="recommend_q_box">
                        <label class="whitespace-nowrap">推荐提问：</label>
                        
                        <div class="q_list" ref="scrollBox2" @wheel="onWheel2">
                            <template v-if="selectedIndex != 0">
                                <div v-for="(item, key) in questionList" :key="key">
                                    <span v-if="item" @click="$emit('handleClick', 'shili', item)" class="spanBox">{{ item }}</span>
                                </div>   
                            </template>

                            <template v-else>
                                <div v-for="(item, key) in questionList" :key="key" class="flex flex-row">
                                    <span v-if="item" 
                                      :title="item.title"
                                      @click="$emit('handleClick', 'shili', item.title)" 
                                      class="spanBox">
                                        {{ item.cate }}
                                        <!-- <label class="hidden">{{ item.title }}</label> -->
                                    </span>
                                </div>   
                            </template>
                        </div>
                        
                        <i class="el-icon-refresh" v-if="selectedIndex != 0" @click="refresh"></i>        
                    </div>   
                </div>
            </div>
        </div>
        <div class="sm:hidden">
            <div class="phone_depart">
                <div class="phone_depart_tab_box">
                    <div class="phone_depart_tab">
                        <span class="py-1.5 mr-7" @click="changeTab(item, key)" 
                            :class="{active: key == selectedIndex}" 
                            v-for="(item, key) in departList" :key="key"
                        >{{item.name}}</span>
                    </div>
                </div>
                <div class="phone_tip_list"
                    element-loading-text="模板加载中"
                    element-loading-spinner="el-icon-loading"
                    v-loading="loading"
                >
                    
                    <template v-if="selectedIndex != 0">
                        <div v-for="(item, key) in questionList" :key="key" 
                          @click="$emit('handleClick', 'shili', item)">
                           <span v-if="item" class="phone_tip_list_item">{{ item }}</span>
                        </div>
                    </template>

                    <template v-else>
                        <div v-for="(item, key) in questionList" :key="key" 
                          class="flex flex-col"
                          @click="$emit('handleClick', 'shili', item.title)" >
                            <span v-if="item" class="phone_tip_list_item">
                                <b>{{ item.cate }}</b>：{{ item.title }}
                            </span>
                        </div>   
                    </template>
                    <div class="w-full">
                        <div class="flex justify-end">
                            <i  v-if="selectedIndex != 0" class="el-icon-refresh text-[22px]" @click="refresh"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            departListShow: false,
            departName: '',
            selectedIndex: 0, // 默认选中的第几项
            departList: [],
            // questionList: ['诊断建议', '治疗方案推荐', '药物副作用查询','英译中','中译英','医学知识普及','病例分析讨论','写作指导','辅助写作'],
            questionList: [],
            templateShow: false,
            loading: false
        }
    },
    mounted() {
        this.getDepart(),
        this.getRecList()
        // this.$refs.scrollBox.addEventListener("wheel", this.onWheel)
    },
    beforeDestroy(){
        // this.$refs.scrollBox.removeEventListener("wheel", this.onWheel)
    },
    methods: {
        getDepart() {
            let params = {
                token: window.localStorage.getItem('token')
            }
            this.$api.getdepart(params).then((res)=>{
                this.departList = res.data
                this.departList.unshift({id: '',name: '推荐'})
            }).finally(() => {
                // 隐藏AI聊天中的提问模板
                // this.departListShow = true
            })
        },
        getdepartquestion() {
            let params = {
                token: window.localStorage.getItem('token'),
                department: this.departName
            }
            this.$api.getdepartquestion(params).then((res)=>{
                this.questionList = res.data
            }).finally(()=>{
                this.loading = false
            })
        },
        changeTab(item, key) {
            if (this.selectedIndex == key) return
            this.selectedIndex = key
            this.departName = item.name
            if (item.name == '推荐') {
                // this.questionList = ['诊断建议', '治疗方案推荐', '药物副作用查询', '英译中', '中译英', '医学知识普及', '病例分析讨论', '写作指导', '辅助写作']
                this.getRecList()
            } else {
                this.loading = true
                this.questionList = []
                this.getdepartquestion()
            }
            
        },
        refresh() {
            this.loading = true
            this.questionList = []
            this.getdepartquestion()
        },
        onWheel(event){
            const scrollCont = this.$refs.scrollBox
            const scrollAmount = event.deltaY < 0 ? -100 :100
            scrollCont.scrollLeft += scrollAmount
            event.preventDefault()
        },
        onWheel2(event) {
            const scrollCont2 = this.$refs.scrollBox2
            const scrollAmount = event.deltaY < 0 ? -100 : 100
            scrollCont2.scrollLeft += scrollAmount
            event.preventDefault()
        },
        getRecList() {
            let params = {
                token: window.localStorage.getItem('token'),
            }
            // this.$api.putforwardList(params).then(res => {
            //     this.questionList = res.data
            // })
        }
    }
}
</script>

<style lang='scss' scoped>
::v-deep .el-loading-spinner {
    @apply flex justify-center items-center top-[50%] max-sm:mt-[-10px] left-[50%] ml-[-50%];
    .el-icon-loading {
        @aaply text-[15px] mr-[5px];
    }
}
.web_depart {
    .tab_box {
        @apply relative text-[#ff0000] h-8 mb-[17px];
    }
    .depart_tab {
        @apply absolute right-0 left-0 w-full text-[#A0A3AE] flex-nowrap overflow-x-auto flex flex-row text-sm;
    }
    .depart_tab span {
        width: fit-content;
        white-space: nowrap;
        cursor: pointer;
    }
    .depart_tab span:last-child {
        margin-right: 0;
    }
    .depart_tab::-webkit-scrollbar {
        width: 100%;
        height: 3px;
    }
    .depart_tab::-webkit-scrollbar-thumb {
        background: #ddd; 
        border-radius: 5px;
    }
    .depart_tab::-webkit-scrollbar-track {
        border-radius: 5px;
    }
    .tip_list {
        @apply min-h-[32px] flex justify-between text-xs items-center mb-3;
        color: #A0A3AE;
        .recommend_q_box{
            @apply relative w-full flex items-center justify-between;
            .q_list{
                width: calc(100% - 90px);
                @apply absolute right-5 left-16 pl-1 flex-1 flex flex-row flex-nowrap overflow-x-auto;
                &::-webkit-scrollbar {
                    width: 100%;
                    height: 3px;
                }
                &::-webkit-scrollbar-thumb {
                    background: #ddd; 
                    border-radius: 5px;
                }
                &::-webkit-scrollbar-track {
                    border-radius: 5px;
                }
                .spanBox {
                    @apply inline-block text-sm text-[#333333] whitespace-nowrap mr-3 px-3 bg-white h-8 leading-8 rounded-[10px] cursor-pointer;
                }
                .spanBox:hover{
                    @apply text-[#4C5BDF];
                }
            }   
            .el-icon-refresh {
                @apply text-xl text-[#A0A3AE] cursor-pointer w-5 h-7;
            }
        }
    }
}

.active {
    @apply relative text-[#4C5BDF] font-semibold;
}
.active::after {
    content: '';
    @apply absolute right-0 bottom-0 left-0 bg-[#4C5BDF] h-[3px]  rounded-sm;
}
.phone_depart {
    @apply px-4 w-full flex flex-col;
    .phone_depart_tab_box {
        @apply relative text-[#A0A3AE];
        .phone_depart_tab {
            @apply w-full absolute right-0 left-0 overflow-auto flex-nowrap text-[#A0A3AE] flex flex-row text-sm;
            &::-webkit-scrollbar {
                display: none;
            }
            span {
                @apply whitespace-nowrap cursor-pointer;
                &:last-child {
                    @apply mr-0;
                }
            }
        }
    }
    .phone_tip_list {
        @apply mt-[46px] text-xs items-center;
        .phone_tip_list_item {
            @apply px-4 py-3 mb-2 inline-block bg-white rounded-[10px]  text-[15px] leading-[22px];
            &:active{
                @apply text-[#4C5BDF];
            }
        }
        .el-icon-refresh {
            @apply mt-2.5 text-[#A0A3AE] cursor-pointer;
        }
    }
}
</style>